import {observer} from 'mobx-react-lite'
import React from 'react'
import {DataObjectId} from 'yougile-model'
import {Sync} from '@client/sync'
import {useTasksListStore} from '@components/my-tasks/tasks-list/tasks-list-store'
import {StickerItem} from '@components/sticker'
import {systemStickerCtl} from '@extensions/sticker/sticker'

export const TaskDeadlineColumn = observer(
  ({taskId}: {taskId: DataObjectId}) => {
    const [, store] = useTasksListStore()
    const box = Sync.getCurrentSandbox()
    const ctl = systemStickerCtl.Deadline
    const sticker = ctl.getSticker(box)
    const { sort } = store;
    const sortedByDeadline = sort && sort.columnId === 'deadline';

    return (
      <div onClick={event => event.stopPropagation()}>
        <StickerItem
          withMenu
          closeMenuAfterPin={sortedByDeadline}
          location="task"
          taskId={taskId}
          sticker={sticker}
        />
      </div>
    )
  }
)
